import { Campaign } from './Campaign';

export enum LeadStatus {
  PENDING = 'PENDING',
  SAVED = 'SAVED',
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED',
  NO_LEAD = 'NO_LEAD',
}

export type LeadStatusCount = {
  TOTAL: number;
} & {
  [key in LeadStatus]?: number;
};

export type Lead = {
  _id: string;
  jobTitle: string;
  jobType: string;
  companyName: string;
  has_email: boolean;
  companyInfo: string;
  location: string;
  fullJobDescription: string;
  salary: string;
  minMonthly: string;
  maxMonthly: string;
  campaignId: string;
  listingUrl: string;
  createdAt: string;
  url?: string;
  isArchived: boolean;
  campaign?: Campaign;
  availableLeads?: Lead[];
  contact?: {
    _id: string;
    email: string;
    firstOutreach: string;
    firstSubject: string;
    firstName: string;
    lastName: string;
    leadStatus: LeadStatus;
    apollo_id: string;
  };
};

export type PersonalLead = {
  _id: string;
  email: string;
  website: string;
  last_name: string;
  first_name: string;
  company_name: string;
  phone: string;
  leadStatus: string;
  apollo_id: string;
  linkedin_url: string;
  title: string;
  state: string;
  city: string;
  country: string;
  personalCampaignId: string;
  keywords: string;
  industry: string;
  first_outreach: string;
  first_subject: string;
  createdAt: string;
  updatedAt: string;
};

export type LeadApiResponse = {
  _id: string;
  jobTitle: string;
  jobType: string;
  companyName: string;
  companyInfo: string;
  location: string;
  hasReplied?: boolean;
  title: string;
  fullJobDescription: string;
  salary: string;
  minMonthly: string;
  maxMonthly: string;
  campaignId: string;
  listingUrl: string;
  createdAt: string;
  url?: string;
  isArchived: boolean;
  campaign: Campaign;
  lastEmailSent: string;
  lead?: {
    _id: string;
    email: string;
    title: string;
    first_outreach: string;
    first_subject: string;
    first_name: string;
    last_name: string;
    leadStatus: LeadStatus;
    apollo_id: string;
  };
};
